<lbt-modal
  [footerTmpl]="footerTmpl"
  [bodyTmpl]="confirmationBodyTmpl"
  [showHeader]="resolvedShowHeader()"
  [showCloseIcon]="resolvedShowCloseIcon()"
  [noDivider]="resolvedNoDivider()"
  [title]="resolvedTitle()"
></lbt-modal>

<ng-template #footerTmpl>
  <div class="confirmation-footer">
    @if (!resolvedHideCancelBtn()) {
      <lbt-button
        mat-dialog-close
        class="m-r-2"
        color="white"
        (click)="onCancel()"
      >
        {{ resolvedCancelText() }}
      </lbt-button>
    }
    <lbt-button
      (click)="onConfirm()"
      [mat-dialog-close]="true"
      class="confirmation-ok-btn"
      [ngClass]="resolvedConfirmClass()"
      [color]="resolvedOkType()"
      [disabled]="disableConfirm() ?? false"
    >
      {{ resolvedOkText() }}
    </lbt-button>
  </div>
</ng-template>

<ng-template #confirmationBodyTmpl>
  <div class="confirmation-body body1-black-8">
    @if (confirmContentTmpl()) {
      <ng-container
        *ngTemplateOutlet="confirmContentTmpl(); context: { $implicit: data?.contextData }"
      ></ng-container>
    } @else {
      <div [innerHTML]="confirmContentHtml()"></div>
    }
  </div>
</ng-template>

<ng-template #headerBodyTmpl>
  <div>
    @if (headerContentTmpl()) {
      <ng-container *ngTemplateOutlet="headerContentTmpl()"></ng-container>
    } @else {
      <div [innerHTML]="headerContentHtml()"></div>
    }
  </div>
</ng-template>
